export default {
  namespaced: true,
  getters: {
    getPaymentStatuses: () => () => {
      return ["pending_payment", "paid", "processing"];
    },

    getTransactionTypes: () => () => {
      return ["bill", "statement"];
    },
  },
};
